<script setup lang="ts">
import './assets/style.scss'
import { type PropType } from 'vue'
import type { ScheduleEditTypes } from './../model/type.ts'
import { useModel } from './../model/model.ts'

const props = defineProps({
  scheduleId: {
    type: Number,
    required: true,
  },
  type: {
    type: String as PropType<ScheduleEditTypes>,
    default: 'rename',
  },
})

const model = useModel()

/**
 * Функция обработчик кнопки открытия
 */
const clickHandler = () => {
  if (!props.scheduleId) return

  model.editType = props.type
  model.openForm = true
  model.editId = props.scheduleId
}
</script>

<template>
  <div @click="clickHandler">
    <slot />
  </div>
</template>
